/**
 * @generated SignedSource<<6db93e1705418f596173706f8da5f553>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InteractiveWidgetWrapper_widget$data = {
  readonly __typename: string;
  readonly id: string;
  readonly isResizable?: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"widgetSettingsAvailable_widget">;
  readonly " $fragmentType": "InteractiveWidgetWrapper_widget";
};
export type InteractiveWidgetWrapper_widget$key = {
  readonly " $data"?: InteractiveWidgetWrapper_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"InteractiveWidgetWrapper_widget">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InteractiveWidgetWrapper_widget",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isResizable",
          "storageKey": null
        }
      ],
      "type": "WidgetNote",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "widgetSettingsAvailable_widget"
    }
  ],
  "type": "Widget",
  "abstractKey": "__isWidget"
};

(node as any).hash = "87ee350c232412e34d4041cf1d50b4e2";

export default node;
